/* eslint-disable max-len */
import { FC } from 'react';
import cx from 'clsx';

// types
import { IGlyphIcon } from './shared';

// styles
import { useStyles } from './shared/styles';

const Attach: FC<IGlyphIcon> = ({ className, color, onClick, ...rest }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.88536 5.17093L6.1147 8.94227C6.05102 9.00376 6.00023 9.07733 5.96529 9.15866C5.93036 9.24 5.91196 9.32748 5.91119 9.416C5.91043 9.50452 5.92729 9.59231 5.96081 9.67424C5.99433 9.75617 6.04384 9.8306 6.10643 9.8932C6.16903 9.95579 6.24346 10.0053 6.32539 10.0388C6.40732 10.0723 6.49511 10.0892 6.58363 10.0884C6.67215 10.0877 6.75963 10.0693 6.84096 10.0343C6.9223 9.99939 6.99586 9.94861 7.05736 9.88493L10.8287 6.11427C11.2038 5.73916 11.4145 5.23041 11.4145 4.69993C11.4145 4.16945 11.2038 3.6607 10.8287 3.2856C10.4536 2.91049 9.94484 2.69976 9.41436 2.69976C8.88388 2.69976 8.37513 2.91049 8.00003 3.2856L4.22869 7.05693C3.91275 7.36502 3.66111 7.73277 3.4884 8.13886C3.31569 8.54496 3.22532 8.9813 3.22256 9.42259C3.21979 9.86387 3.30468 10.3013 3.47229 10.7095C3.63991 11.1178 3.88691 11.4886 4.19897 11.8007C4.51104 12.1127 4.88195 12.3596 5.2902 12.5272C5.69845 12.6947 6.1359 12.7796 6.57719 12.7767C7.01847 12.7739 7.4548 12.6835 7.86087 12.5107C8.26693 12.3379 8.63465 12.0863 8.94269 11.7703L12.714 7.9996L13.6567 8.94227L9.88536 12.7136C9.452 13.147 8.93752 13.4907 8.37131 13.7253C7.80509 13.9598 7.19823 14.0805 6.58536 14.0805C5.9725 14.0805 5.36563 13.9598 4.79941 13.7253C4.2332 13.4907 3.71872 13.147 3.28536 12.7136C2.852 12.2802 2.50824 11.7658 2.2737 11.1995C2.03917 10.6333 1.91846 10.0265 1.91846 9.4136C1.91846 8.80073 2.03917 8.19387 2.2737 7.62765C2.50824 7.06144 2.852 6.54696 3.28536 6.1136L7.05736 2.34293C7.68604 1.73574 8.52804 1.39976 9.40203 1.40735C10.276 1.41495 11.1121 1.76551 11.7301 2.38354C12.3481 3.00156 12.6987 3.83761 12.7063 4.7116C12.7139 5.58559 12.3779 6.42759 11.7707 7.05627L8.00003 10.8289C7.81425 11.0147 7.59371 11.162 7.351 11.2625C7.10829 11.363 6.84816 11.4147 6.58546 11.4147C6.32276 11.4146 6.06264 11.3629 5.81996 11.2623C5.57727 11.1618 5.35676 11.0144 5.17103 10.8286C4.9853 10.6428 4.83797 10.4223 4.73747 10.1796C4.63697 9.93686 4.58526 9.67673 4.58529 9.41403C4.58532 9.15133 4.63709 8.89122 4.73765 8.64853C4.83821 8.40584 4.98558 8.18533 5.17136 7.9996L8.94269 4.22827L9.88536 5.17093Z"
        fill={color}
      />
    </svg>
  );
};

export default Attach;
